import { Component, Input, ViewChild, ElementRef, HostListener, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

interface Staff {
  name: string;
  emailId: string;
}

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    standalone: false
})
export class AutocompleteComponent implements OnInit, OnChanges {

  @Input() careMembers: Staff[] = [];
  @Input() noResult: boolean = false; 
  @Input() typedText: string = '';
  @Input() clearFormFiled: boolean = false;
  @Input() isDropdownDisabled: boolean = true;
  
  @ViewChild('searchInput') searchInput!: ElementRef;
  @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;

  @Output() searchChanged = new EventEmitter<string>();  
  @Output() selectedCareMemberValues = new EventEmitter<Staff | null>(); 

  filteredStates: Staff[] = [];
  searchText: string = '';
  dropdownOpen: boolean = false;

  ngOnInit() {
    this.initializeDropdown();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['careMembers']) {
      this.initializeDropdown();
    }

    if (changes['clearFormFiled']?.currentValue) {
      this.searchText = 'Any';
      this.filteredStates = [];
      this.dropdownOpen = false;
      this.selectedCareMemberValues.emit(null);
    }

    if (changes['typedText'] && changes['typedText'].currentValue === '') {
      this.searchText = 'Any';
      this.filteredStates = [];
      this.dropdownOpen = false;
      this.selectedCareMemberValues.emit(null);
    }
  }

  private initializeDropdown() {
    if (this.careMembers && this.careMembers.length > 0) {
      if (this.typedText) {
        const defaultCareMember: any = this.careMembers.find(
          (item: any) => item.id == this.typedText
        );

        if (defaultCareMember) {
          this.searchText = defaultCareMember.name + ' - ' + defaultCareMember.emailId;
          this.selectedCareMemberValues.emit(defaultCareMember);
        }

        this.filteredStates = [...this.careMembers];
      } else {
        this.searchText = 'Any';
        this.filteredStates = [...this.careMembers];
        this.selectedCareMemberValues.emit(null);
      }
    } else {
      this.searchText = 'Any';
      this.filteredStates = [];
      this.dropdownOpen = false;
      this.selectedCareMemberValues.emit(null);
    }
  }

  onSearchChange() {
    if (this.searchText && this.searchText !== 'Any') {
      const searchLower = this.searchText.toLowerCase();
      this.filteredStates = (this.careMembers ?? []).filter(
        s => s.name.toLowerCase().includes(searchLower) ||
             s.emailId.toLowerCase().includes(searchLower)
      );
      this.dropdownOpen = this.filteredStates.length > 0;
    } else {
      this.searchChanged.emit('');
      this.filteredStates = [...(this.careMembers ?? [])];
      this.dropdownOpen = this.filteredStates.length > 0;
    }
  }

  focusInput() {
    this.searchInput.nativeElement.focus();
    this.filteredStates = [...(this.careMembers ?? [])];
    this.dropdownOpen = this.filteredStates.length > 0;
  }

  selectState(staff: Staff | null) {
    if (staff) {
      this.searchText = staff.name + ' - ' + staff.emailId;
      this.selectedCareMemberValues.emit(staff);
    } else {
      this.searchText = 'Any';
      this.selectedCareMemberValues.emit(null);
    }

    this.filteredStates = [];
    this.dropdownOpen = false;
  }

  clearSelection() {
    this.searchText = 'Any';
    this.filteredStates = [];
    this.selectedCareMemberValues.emit(null);
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (this.dropdownWrapper && !this.dropdownWrapper.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }
}
